<template>
	<div class=" index_content">
		<div class="title">{{name}}</div>
		<div class="answerbox">
			<div class="answerbox_left">
				<div class="top" v-if="isSeeAnswer == false">
					<div class="progress">答题进度：<span class="num">{{CurrentProgress}}</span> /{{numlist}}</div>
					<div class="time">
						<img src="../../assets/imgs/icon_p15@2x.png" />{{timeLeft}}
					</div>
				</div>

				<template v-for="(item,index) in questionList">
					<div v-if="currentQuestion==item" :key="index">
						<div class="topicbox">
							<span v-if="item.questiontype_text == '选择题'">
								<span v-if="item.answerarr.length==1">【单选题】</span>
								<span v-if="item.answerarr.length>1">【多选题】</span>
							</span>
							<span v-if="item.questiontype_text == '判断题'">【判断题】</span>
							<div class="quest_read" v-if="item.read" v-html="item.read"></div>
							<div class="topic">{{index+1}}.<span v-html="item.stem"></span>
							</div>
							<div class="" v-if="item.sketch">
								<img style="max-width: 100%;" :src="item.sketch" />
							</div>

							<!-- questiontype 题型：1选择题2判断题 -->
							<div v-if="item.questiontype == 1">
								<!-- 单选（通过答案数组的长度来判断） -->
								<div class="option" v-if="item.answerarr.length==1">
									<template v-for="(items,indexs) in item.option">
										<!-- 01展示答案和解析  && isSeeAnswer == true-->
										<!-- @click="singleChoiceFun(item,items.option,indexs,item.answer)" -->
										<div v-if="items.answer !== null && items.answer !== '' && isSeeAnswer == true"
											:key="indexs" class="item "
											:class="{'item_success': item.xuanxiang == item.answer && item.seleindex==indexs, 'item_err': item.xuanxiang !='' && item.xuanxiang != item.answer && item.seleindex==indexs}"
											:disabled="item.correct == undefined">
											<div class="option_num">{{items.option}}</div>
											<div class="option_con" v-html="items.answer"></div>
										</div>

										<!-- 02正常答题 且不展示答案和解析 -->
										<div v-if="items.answer !== null && items.answer !== '' && isSeeAnswer == false"
											:key="indexs" class="item"
											:class="{'item_xuanzhong': item.xuanxiang != ''&& item.seleindex===indexs}"
											@click="singleChoiceFun(item,items.option,indexs,item.answer)">
											<div class=" option_num">{{items.option}}</div>
											<div class="option_con" v-html="items.answer"></div>
										</div>
									</template>
								</div>

								<!-- 多选 -->
								<div class="option" v-else>
									<template v-for="(items,indexs) in item.option">
										<!-- 01展示答案和解析 -->
										<!-- @click="multipleChoiceFun(item,items.option,indexs,item.answer)"  :disabled="item.correct == undefined"-->
										<div v-if="items.answer !== null && items.answer !== ''  && isSeeAnswer == true"
											:key="indexs" class="item"
											:class="{'item_select': item.selectedMultiple.includes(items.option),
											'item_success':item.answerarr.includes(items.option) && item.correct != undefined,
											'item_err':item.selectedMultiple.includes(items.option) && !item.answerarr.includes(items.option)&& item.correct != undefined}">
											<div class="option_num">{{items.option}}</div>
											<div class="option_con" v-html="items.answer"></div>
										</div>

										<!-- 02正常答题 且不展示答案和解析 -->
										<div v-if="items.answer !== null && items.answer !== ''  && isSeeAnswer == false"
											:key="indexs" class="item"
											:class="{'item_xuanzhong': item.selectedMultiple.includes(items.option)}"
											@click="multipleChoiceFun(item,items.option,indexs,item.answer)"
											:disabled="item.correct == undefined">
											<div class="option_num">{{items.option}}</div>
											<div class="option_con" v-html="items.answer"></div>
										</div>
									</template>
									<!-- <div class="confirmAnswer" v-if="item.correct == undefined"
										@click="confirmAnswer(item,item.answer)">
										确认答案
									</div> -->
								</div>
							</div>

							<!-- 判断题（对、错） -->
							<!-- 01展示答案和解析 -->
							<div class="determine" v-if="item.questiontype == 2 && isSeeAnswer == true">
								<div class="item"
									:class="{'item_dui': item.xuanxiang == item.answer && item.seleindex==indexs, 'item_cuo': item.xuanxiang != item.answer && item.seleindex == indexs}"
									v-for="(items,indexs) in item.trueOrFalse" :key="indexs"
									@click="trueOrFalseFun(item,items,indexs)" :disabled="item.correct == undefined">
									{{items}}
								</div>
							</div>

							<!-- 02正常答题 且不展示答案和解析 -->
							<div class="determine" v-if="item.questiontype == 2 && isSeeAnswer == false">
								<div class="item"
									:class="{'item_determine_select': item.xuanxiang != '' && item.seleindex===indexs}"
									v-for="(items,indexs) in item.trueOrFalse" :key="indexs"
									@click="trueOrFalseFun(item,items,indexs)" :disabled="item.correct == undefined">
									{{items}}
								</div>
							</div>
						</div>

						<!-- 答题解析 -->
						<div class="answerKey" v-if="item.correct != undefined && isSeeAnswer == true">
							<!-- 答案 -->
							<div class="keybox">
								<div class="item">
									<div>正确答案</div>
									<div class="select_one">{{item.answer}}</div>
								</div>
								<div class="item">
									<div>你的答案</div>
									<!-- 单选 -->
									<div v-if="item.answerarr.length==1"
										:class="item.answer == item.xuanxiang ?' select_one':'select_two'">
										{{item.xuanxiang}}
									</div>

									<!-- 多选 -->
									<div v-if="item.answerarr.length>1"
										:class="item.correct == 1 ?' select_one':'select_two'">
										{{item.xuanxiang}}
									</div>
								</div>
							</div>
							<!-- 解析 -->
							<div class="analysis">
								<div class="analysisCon">
									<div class="headertit">解&nbsp;&nbsp;&nbsp;&nbsp;析</div>
									<div class="infos" v-html="item.analysis"></div>
								</div>
							</div>
							<!-- 知识树 -->
							<div class="analysis knowledgeTree">
								<div class="analysisCon">
									<div class="headertit">知识树</div>
									<div class="infos">
										<div v-html="item.introduce"></div>
										<div v-if="item.image.length > 0">
											<img v-for="(items,indexs) in item.image" :key='indexs' :src="items" />
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</template>
				<div class="btnbox">
					<!-- 移动端展示答题卡按钮 -->
					<div class="datika" @click="answerSheetFun()">
						<img src="../../assets/imgs/icon11@2x.png" />
						答题卡
					</div>
					<div class="btn prevbtn" v-if="currentQuestionIndex !== 0"
						@click="prevQuestion(currentQuestionIndex)" :disabled="isFirstQuestion">上一题
					</div>
					<div class="btn nextbtn showbtnsty" @click="submitFun()" v-if="isSeeAnswer == false&&(currentQuestionIndex == questionList.length-1) && ((questionList[questionList.length-1].questiontype==1&&questionList[questionList.length-1].answerarr.length==1&&questionList[questionList.length-1].xuanxiang!='')||(questionList[questionList.length-1].questiontype==2&&questionList[questionList.length-1].xuanxiang!='')||(questionList[questionList.length-1].questiontype==1&&questionList[questionList.length-1].answerarr.length>1&&questionList[questionList.length-1].selectedMultiple.length>0))">交卷</div>
					<div class="btn nextbtn" v-if="currentQuestionIndex < questionList.length - 1"
						@click="nextQuestion(currentQuestionIndex)" :disabled="isLastQuestion">下一题</div>
				</div>
			</div>

			<!-- PC答题卡 -->
			<div class="answerbox_right">
				<div class="top">答题卡</div>
				<!-- 01 答题后展示 -->
				<div class="numbox" v-if="isSeeAnswer == true">
					<!-- 当前：cur  错误：err  正确：sucess -->
					<div class="item" :class="{'sucess': questionList[index].correct == 1, 
						'err': questionList[index].correct == 0,
						'cur': index == currentQuestionIndex}" v-for="(item,index) in numlist" :key="index" @click="goToQuestion(index)">
						{{item}}
					</div>
				</div>

				<!-- 02 答题中展示 -->
				<div class="numbox" v-if="isSeeAnswer == false ">
					<!-- 当前：cur  num_select 已答题-->
					<template v-for="(item,index) in numlist">
						<!-- 多选 -->
						<div class="item" v-if="questionList[index].answerarr.length > 1" :key="index"
							:class="{'num_select':questionList[index].correct != undefined && questionList[index].selectedMultiple.length >0}"
							@click="goToQuestion(index)">
							{{item}}
						</div>
						<!-- 其他（单选、判断） -->
						<div class="item" v-if="questionList[index].answerarr.length == 1" :key="index"
							:class="{'num_select':questionList[index].correct != undefined}"
							@click="goToQuestion(index)">
							{{item}}
						</div>
					</template>
				</div>
				<div class="submit" v-if="isSeeAnswer == false" @click="submitFun()">交卷</div>
			</div>
		</div>

		<!-- 手机端-答题卡 -->
		<div class="maskingout" v-if="answerSheet == true">
			<div class="popaminatsty answerSheet">
				<div class="tit">答题卡<img @click="answerSheet = false" class="imgclose"
						src="../../assets/imgs/close.png" />
				</div>
				<!-- 01 答题后展示 -->
				<div class="numbox" v-if="isSeeAnswer == true">
					<!-- 当前：cur  错误：err  正确：sucess -->
					<div class="item" :class="{'sucess': questionList[index].correct == 1, 
						'err': questionList[index].correct == 0,
						'cur': index == currentQuestionIndex}" v-for="(item,index) in numlist" :key="index" @click="goToQuestion(index)">
						{{item}}
					</div>
				</div>

				<!-- 02 答题中展示 -->
				<div class="numbox" v-if="isSeeAnswer == false">
					<!-- 当前：cur  num_select 已答题-->
					<!-- <div class="item" :class="{'num_select': questionList[index].correct != ''}"
						v-for="(item,index) in numlist" :key="index" @click="goToQuestion(index)">
						{{item}}
					</div> -->


					<template v-for="(item,index) in numlist">
						<!-- 多选 -->
						<div class="item" v-if="questionList[index].answerarr.length > 1" :key="index"
							:class="{'num_select':questionList[index].correct != undefined && questionList[index].selectedMultiple.length >0}"
							@click="goToQuestion(index)">
							{{item}}
						</div>
						<!-- 其他（单选、判断） -->
						<div class="item" v-if="questionList[index].answerarr.length == 1" :key="index"
							:class="{'num_select':questionList[index].correct != undefined}"
							@click="goToQuestion(index)">
							{{item}}
						</div>

					</template>


				</div>

				<div class="submit" @click="submitFun()" v-if="isSeeAnswer == false">交卷</div>
			</div>
		</div>

		<!-- 考试时间到 @click.stop='close()'-->
		<div class="maskingout" v-if="type==1 && isSeeAnswer == false">
			<examinat :type="1" :submitInfo='submitInfo'></examinat>
		</div>
		<!-- 提交试卷@click.stop='close()' -->
		<div class="maskingout" v-if="type==2">
			<examinat :type="2" :submitInfo='submitInfo'></examinat>
		</div>
	</div>
</template>

<script>
	import examinat from '../../components/examinat.vue'
	export default {
		name: "Answer",
		components: {
			examinat
		},
		data() {
			return {
				numlist: '',
				type: '', //1考试时间到   2提交试卷
				answerSheet: false, //手机端显示答题卡
				id: '',
				questionList: '', //题目数据
				currentQuestionIndex: 0, // 当前题目的索引

				name: '',
				successNum: '', //	是	int	正确数量
				errorNum: '', //	是	int	错题数量
				score: '', //	是	int	得分

				notNum: '', //未答题

				time: null, // 消耗的时间（是	string	答题用时）
				timeLeft: '', //	展示的倒计时
				totalTime: 0, // 35分钟转换为秒 --相同
				initialTime: 0, //初始时间  --相同
				timer: null,

				CurrentProgress: 0, //当前进度
				submitInfo: '', //提交试卷展示的数据（传给子组件）

				//新增
				isSeeAnswer: false, //true:展示答案；false：答题中（不展示答案）
			};
		},
		computed: {
			currentQuestion() {
				return this.questionList[this.currentQuestionIndex]; // 获取当前题目
			},
			isFirstQuestion() {
				return this.currentQuestionIndex === 0; // 判断是否是第一道题
			},
			isLastQuestion() {
				return this.currentQuestionIndex >= this.questionList.length - 1; // 判断是否是最后一道题 
			},
		},
		created() {

			this.loadCountdown()
		},

		mounted() {
			this.id = this.$route.query.id;
			this.name = this.$route.query.name;
			this.initialTime = this.$route.query.time * 60; //初始时间--固定

			//获取倒计时
			if (localStorage.getItem('Time')) {
				this.totalTime = Number(localStorage.getItem('Time'))
				if (localStorage.getItem('totalTime')) {
					this.totalTime = Number(localStorage.getItem('totalTime')); //答题时长
				} else {
					this.totalTime = Number(localStorage.getItem('Time'))
				}
			} else {
				localStorage.setItem('Time', Number(this.$route.query.time * 60))

				this.totalTime = localStorage.getItem('Time'); //答题时长
			}

			//做过的题存入缓存
			if (localStorage.getItem('questionStorage') && !this.$route.query.reportID) {
				const myArray = JSON.parse(localStorage.getItem('questionStorage'));
				this.questionList = myArray || []; // 如果localStorage中没有数据，默认为空数组
				//题目数量
				this.numlist = myArray.length
				//获取答题进度
				const Current = localStorage.getItem('CurrentProgress')
				this.CurrentProgress = Current
			} else if (this.$route.query.reportID) { //有报告id --表示查看答案和解析
				this.getQuestionData(this.$route.query.reportID)
			} else {
				this.getQuestionList() //试题列表
			}

			//查看答案和解析
			if (localStorage.getItem('isSeeAnswer')) {
				this.isSeeAnswer = localStorage.getItem('isSeeAnswer') == 'false' ? false : true
			}

		},
		beforeDestroy() {
			// if(this.$route.name!=="Answer"){
				clearInterval(this.timer); // 清除定时器以防止内存泄漏
				localStorage.removeItem('totalTime'); //清除倒计时缓存
				localStorage.removeItem('Time'); //清除倒计时缓存
				localStorage.removeItem('questionStorage'); //清除答题缓存
				localStorage.removeItem('CurrentProgress'); //清除进度缓存
				localStorage.removeItem('isSeeAnswer'); //清除答案解析缓存
			// }
		},
		methods: {
			//试题列表
			getQuestionList() {
				var that = this
				var data = {
					id: this.id
				}
				this.$api.POST(this.$face.index_questionList, data, function(res) {
					//给每道题设置两个属性-选择的选项
					res.data.forEach(item => {
						that.$set(item, 'xuanxiang', '')
						that.$set(item, 'seleindex', '')
						that.$set(item, 'selectedMultiple', []) //用于多选--存储选择的选项
						if (item.questiontype == 2) { //1选择题  2判断题
							that.$set(item, 'trueOrFalse', ['对', '错']) //用于判断题的显示
						}
					})
					that.questionList = res.data //题目
					that.numlist = res.data.length //题目数量
					that.startTimer(); //倒计时
				});
			},

			//回显数据
			getQuestionData(id) {
				var that = this
				var data = {
					id: id
				}
				this.$api.POST(this.$face.questionData, data, function(res) {
					//将image的字符串类型转为数组类型
					res.data.forEach(item => {
						item.image = item.image ? item.image.split(',') : []; // 处理空值
					})
					that.questionList = res.data //题目
					that.numlist = res.data.length //题目数量
				});
			},


			//单选（点击选项abcdefg）
			singleChoiceFun(item, option, index, correctAnswer) {
				// console.log('该条数据', item, '点击的选项', option, '正确选项', correctAnswer)
				// if (item.correct == undefined) { //未答题的情况
				this.$set(item, 'xuanxiang', option)
				this.$set(item, 'seleindex', index)

				// 设置点击的item的correct--默认0（0 错误 1 正确）
				if (option == correctAnswer) { //正确
					this.$set(item, 'correct', 1)
				} else { //错误
					this.$set(item, 'correct', 0)
				}

				//做过的题存入缓存
				localStorage.setItem('questionStorage', JSON.stringify(this.questionList));
				//答题进度
				const countCorrect = this.questionList.filter(item => item.correct === 1 || item.correct === 0)
					.length;
				// console.log('输出做过题的数量', countCorrect); 
				localStorage.setItem('CurrentProgress', countCorrect);
				this.CurrentProgress = countCorrect

				// //答题进度
				// localStorage.setItem('CurrentProgress', this.CurrentProgress + 1);
				// this.CurrentProgress = this.CurrentProgress + 1
				// } else {
				// 	console.log('已答过题，不可再次点击')
				// }
			},

			//多选（点击选项abcdefg）
			multipleChoiceFun(item, option, index, correctAnswer) {
				// console.log('该条数据', item, '点击的选项', option, '正确选项', correctAnswer)
				// if (item.correct == undefined) { //未答题的情况

				//点击添加该选项，再次点击移除该选项
				const indexof = item.selectedMultiple.indexOf(option);
				if (indexof > -1) { // 如果选项已存在，移除它
					item.selectedMultiple.splice(indexof, 1);
				} else { // 如果选项不存在，添加它
					item.selectedMultiple.push(option);
				}

				this.$set(item, 'xuanxiang', item.selectedMultiple.join(','))
				// console.log('选中的', item.selectedMultiple, '正确答案', answer)

				// js判断两个字符串中的字符是否相同（顺序不影响）
				function areStringsEqual(str1, str2) { // 将字符串转换为字符数组，并排序
					const sortedStr1 = str1.split('').sort().join('');
					const sortedStr2 = str2.split('').sort().join('');
					return sortedStr1 === sortedStr2; // 比较排序后的字符串
				}

				if (areStringsEqual(item.selectedMultiple.join(','), item.answer)) { //答对
					this.$set(item, 'correct', 1)
				} else { //答错
					this.$set(item, 'correct', 0)
				}
				//一个都没选，移除correct
				if (item.selectedMultiple.length == 0) {
					item.correct = null;
				} else {
					//做过的题存入缓存
					localStorage.setItem('questionStorage', JSON.stringify(this.questionList));
					//答题进度
					const countCorrect = this.questionList.filter(item => item.correct === 1 || item.correct === 0)
						.length;
					// console.log('输出做过题的数量', countCorrect);
					localStorage.setItem('CurrentProgress', countCorrect);
					this.CurrentProgress = countCorrect
				}
				// console.log('打印盒子', item.selectedMultiple)
				// if (item.selectedMultiple.length > 0) {
				// 	//做过的题存入缓存
				// 	localStorage.setItem('questionStorage', JSON.stringify(this.questionList));
				// }



				// console.log('选中的选项', item.selectedMultiple)
				// } else {
				// 	console.log('已答过题，不可再次点击')
				// }
			},

			//多选--确认答案
			// confirmAnswer(item, answer) {
			// 	this.$set(item, 'xuanxiang', item.selectedMultiple.join(','))
			// 	// console.log('选中的', item.selectedMultiple, '正确答案', answer)

			// 	// js判断两个字符串中的字符是否相同（顺序不影响）
			// 	function areStringsEqual(str1, str2) {
			// 		// 将字符串转换为字符数组，并排序
			// 		const sortedStr1 = str1.split('').sort().join('');
			// 		const sortedStr2 = str2.split('').sort().join('');
			// 		// 比较排序后的字符串
			// 		return sortedStr1 === sortedStr2;
			// 	}

			// 	if (areStringsEqual(item.selectedMultiple.join(','), answer)) {
			// 		console.log('答对')
			// 		this.$set(item, 'correct', 1)
			// 	} else {
			// 		console.log('答错')
			// 		this.$set(item, 'correct', 0)
			// 	}
			// 	//做过的题存入缓存
			// 	localStorage.setItem('questionStorage', JSON.stringify(this.questionList));
			// 	//答题进度
			// 	// localStorage.setItem('CurrentProgress', this.CurrentProgress + 1);
			// 	// this.CurrentProgress = this.CurrentProgress + 1
			// },

			//判断题（点击选项-对or错）
			trueOrFalseFun(item, myselect, index) {
				// console.log('点击', item, '我的选择：', myselect, '----正确答案：', item.answer)
				// if (item.correct == undefined) { //未答题的情况
				this.$set(item, 'xuanxiang', myselect)
				this.$set(item, 'seleindex', index)

				// 设置点击的item的correct--默认0（0 错误 1 正确）
				if (myselect == item.answer) { //正确
					this.$set(item, 'correct', 1)
				} else { //错误
					this.$set(item, 'correct', 0)
				}
				//做过的题存入缓存
				localStorage.setItem('questionStorage', JSON.stringify(this.questionList));
				//答题进度
				const countCorrect = this.questionList.filter(item => item.correct === 1 || item.correct === 0)
					.length;
				// console.log('输出做过题的数量', countCorrect);
				localStorage.setItem('CurrentProgress', countCorrect);
				this.CurrentProgress = countCorrect

				//答题进度
				// localStorage.setItem('CurrentProgress', this.CurrentProgress + 1);
				// this.CurrentProgress = this.CurrentProgress + 1
				// } else {
				// 	console.log('已答过题，不可再次点击')
				// }
			},

			//下一题
			nextQuestion(index) {
				var that = this
				//如果当前题目未做 &&多选题不为空&&不是最后一道题------不可进行下一题
				if (that.questionList[index].answerarr.length > 1) { //多选题
					if (that.questionList[index].correct != undefined && !this.isLastQuestion && that.questionList[
							index]
						.selectedMultiple.length >
						0) {
						this.currentQuestionIndex++; // 增加当前题目索引
					} else {
						that.$utile.prompt('warning', '请先选择当前题目');
					}
				} else {
					if (that.questionList[index].correct != undefined && !this.isLastQuestion) {
						this.currentQuestionIndex++; // 增加当前题目索引
					} else {
						that.$utile.prompt('warning', '请先选择当前题目');
					}
				}
			},
			//上一题
			prevQuestion(index) {
				if (!this.isFirstQuestion) {
					this.currentQuestionIndex--; // 减少当前题目索引
				}
			},

			//点击答题卡选择
			goToQuestion(index) {
				// console.log('点击题号', index)  
				this.answerSheet = false
				//选择了答案的才可以点击题号跳转
				if (this.questionList[index].correct !== undefined) {
					this.currentQuestionIndex = index; // 设置当前题目索引为点击的题号
				} else {
					this.$utile.prompt('warning', '仅可跳转答过的题');
				}
			},

			//倒计时
			startTimer() {
				this.updateTimeLeft();
				this.timer = setInterval(() => {
					if (this.totalTime > 0) {
						this.totalTime--;
						localStorage.setItem('totalTime', this.totalTime); // 更新 localStorage
						this.updateTimeLeft();
					} else {
						this.successNum = this.questionList.filter(item => item.correct === 1)
							.length; // 统计 correct 为 1 的数量（正确）
						this.errorNum = this.questionList.filter(item => item.correct === 0)
							.length; // 统计 correct 为 0 的数量（错误）
						// 计算答对题目的 grade（得分）
						this.score = this.questionList
							.filter(item => item.correct === 1) // 过滤出 correct 为 1 的项
							.reduce((sum, item) => Number(sum) + Number(item.grade), 0); // 计算 grade 的总和

						//未答题
						this.notNum = this.questionList.length - (this.successNum + this.errorNum)

						console.log('用时', this.time, '正确', this.successNum, '错误', this.errorNum, '得分', this.score,
							'未答题', this.notNum)

						//传给子组件-弹窗展示
						this.submitInfo = {
							successNum: this.successNum,
							errorNum: this.errorNum,
							notNum: this.notNum,
							timeLeft: this.timeLeft,
							score: this.score,
						};
						//时间为0--倒计时结束自动弹出-时间到弹窗--自动提交
						clearInterval(this.timer);
						this.type = 1
						this.getSubmitFun()
					}
					// console.log('打印时间', this.totalTime)
				}, 1000);
			},
			updateTimeLeft() {
				const minutes = Math.floor(this.totalTime / 60);
				const seconds = this.totalTime % 60;
				this.timeLeft = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
			},
			//缓存的时间
			loadCountdown() {
				const storedCountdown = localStorage.getItem('totalTime');
				if (storedCountdown) {
					this.totalTime = storedCountdown; // 从 localStorage 加载倒计时
				} else {
					this.totalTime = this.initialTime; // 如果没有存储，初始化为 35 分钟
				}
			},

			//获取使用了多少时间
			getConsumedTime() {
				this.time = this.initialTime - this.totalTime; // 计算消耗的时间（秒）
				console.log(`消耗的时间: ${this.time} 秒`);
			},

			//关闭弹窗
			close() {
				this.type = ''
			},

			//交卷按钮
			submitFun() {
				var that = this
				const allHaveCorrectField = that.questionList.every(item => 'correct' in item);
				console.log('提交', that.questionList)
				//判断是否每个题都答了
				if (allHaveCorrectField == false) { // 数组中有一条数据没有correct字段，输出 false
					that.$utile.prompt('error', '请完成答题后提交！');
				} else { //每道题都答了
					that.answerSheet = false
					that.getConsumedTime()
					that.successNum = that.questionList.filter(item => item.correct === 1)
						.length; // 统计 correct 为 1 的数量（正确）
					that.errorNum = that.questionList.filter(item => item.correct === 0)
						.length; // 统计 correct 为 0 的数量（错误）
					// 计算答对题目的 grade（得分）
					that.score = that.questionList
						.filter(item => item.correct === 1) // 过滤出 correct 为 1 的项
						.reduce((sum, item) =>  Number(sum) + Number(item.grade), 0); // 计算 grade 的总和

					//未答题
					that.notNum = that.questionList.length - (that.successNum + that.errorNum)
					// console.log('用时', that.time, '正确', that.successNum, '错误', that.errorNum, '得分', that.score, '未答题',
					// 	that.notNum)

					//传给子组件-弹窗展示
					that.submitInfo = {
						successNum: that.successNum,
						errorNum: that.errorNum,
						notNum: that.notNum,
						timeLeft: that.timeLeft,
						score: that.score,
					};
					that.type = 2
				}
			},

			//提交试卷-方法（点击立即交卷）
			getSubmitFun() {
				var that = this
				var data = {
					question: that.questionList, // 是 array 答题记录（ 是否正确： correct： 0 错误1正确）
					time: that.time, //	是	string	答题用时
					success: that.successNum, //是	int	正确数量
					error: that.errorNum, //是	int	错题数量
					// score: that.score, //	是	int	得分（grade字段相加）
				}

				console.log('用时', that.time)
				this.$api.POST(this.$face.index_subQuestion, data, function(res) {
					if (res.code == 1) {
						that.$utile.prompt('success', res.msg);
						//清空题目缓存
						// localStorage.removeItem('questionStorage')
						//返回的数据展示
						let scoreData = {
							scorenum: res.data.scorenum, //得分
							accuracy: res.data.accuracy, //个人正确率
							success: res.data.success, //正确数
							error: res.data.error, //错误数
							avgaccuracy: res.data.avgaccuracy, //平均正确率
						};

						localStorage.setItem('scoreData', JSON.stringify(scoreData));

						//type: '', //1考试时间到   2提交试卷
						if (that.type == 2) {
							setTimeout(() => {
								that.$router.replace({
									path: '/completed',
									query: {
										id: res.data.id, //报告id
									}, //参数,多个用逗号分隔
								})

							}, 1500);
						}

					} else {
						that.$utile.prompt('none', res.msg);
					}
				});
			},

			//查看测试结果
			ViewResultsFun() {
				this.$router.replace({
					path: '/completed',
					query: {
						id: this.id,
					}, //参数,多个用逗号分隔
				})
			},
			//手机端
			answerSheetFun() {
				this.answerSheet = true
			},
			sj_submitFun() {
				this.answerSheet = false
				this.type = 2
			}

		},
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.title {
		margin-bottom: 13px;
		font-size: 18px;
		font-weight: 700;
		letter-spacing: 0px;
		color: rgba(0, 0, 0, 1);
	}

	.answerbox {
		width: 100%;
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
	}

	.answerbox_left {
		width: 850px;
		height: auto;
		opacity: 1;
		border-radius: 5px;
		box-sizing: border-box;
	}

	.answerbox_right {
		width: 335px;
		height: auto;
		opacity: 1;
		background: rgba(255, 255, 255, 1);
		box-sizing: border-box;
		padding-bottom: 30px;
	}

	.answerbox_left .quest_read {

		text-align: justify;
		text-indent: 2em;
	}

	.answerbox_left .top {
		border-radius: 5px 5px 0 0;
		height: 60px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		letter-spacing: 0px;
		width: 100%;
		box-sizing: border-box;
		padding: 15px 20px;
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
		background: rgba(255, 255, 255, 1);

	}


	.answerbox_left .top .progress {
		/** 文本1 */
		font-size: 14px;
		font-weight: 400;
		color: rgba(153, 153, 153, 1);

	}

	.answerbox_left .top .progress .num {
		/** 文本2 */
		font-size: 18px;
		font-weight: 700;
		color: rgba(62, 136, 254, 1);
	}

	.answerbox_left .top .time {
		font-size: 14px;
		font-weight: 400;
		color: rgba(153, 153, 153, 1);
		display: flex;
		align-items: center;

	}

	.answerbox_left .top .time img {
		width: 15px;
		margin-right: 10px;
	}

	.answerbox_right .top {
		border-radius: 5px 5px 0 0;
		height: 60px;
		display: flex;
		align-items: center;
		justify-content: center;
		letter-spacing: 0px;
		width: 100%;
		box-sizing: border-box;
		padding: 20px 20px 10px;
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
		font-size: 16px;
		font-weight: 400;
		letter-spacing: 0px;
		color: rgba(0, 0, 0, 1);
	}

	.answerbox_left .topicbox {
		border-radius: 0 0 5px 5px;
		background: rgba(255, 255, 255, 1);
		width: 100%;
		box-sizing: border-box;
		padding: 18px 30px 35px;
		white-space: pre-wrap;
	}


	.answerbox_left .topicbox .topic {
		font-size: 16px;
		font-weight: 500;
		letter-spacing: 0px;
		color: rgba(0, 0, 0, 1);
		margin: 10px 0;
		display: flex;
		align-items: baseline;
		white-space: pre-wrap;
	}
	.answerbox_left .topicbox .topic /deep/ img{
		max-width: 100%;
	}

	.answerbox_left .topicbox .option {
		margin-top: 40px;
		width: 100%;
	}

	.answerbox_left .topicbox .option .item {
		width: 100%;
		opacity: 1;
		border-radius: 10px;
		background: rgba(246, 250, 255, 1);
		box-sizing: border-box;
		margin-bottom: 10px;
		padding: 10px 15px;
		display: flex;
		align-items: center;
		cursor: pointer;
	}

	.answerbox_left .topicbox .option .option_num {
		width: 30px;
		height: 30px;
		opacity: 1;
		background: rgba(255, 255, 255, 1);
		border: 1px solid rgba(229, 229, 229, 1);

		font-size: 16px;
		font-weight: 500;
		letter-spacing: 0px;
		color: rgba(51, 51, 51, 1);
		border-radius: 50%;
	}

	.answerbox_left .topicbox .option .option_con {
		margin-left: 20px;
		width: 700px;
		font-size: 16px;
		font-weight: 400;
		letter-spacing: 0px;
		color: rgba(51, 51, 51, 1);
	}

	.option_con>>>img {
		max-width: 100% !important;
	}

	.item_err {
		width: 100%;
		opacity: 1;
		border-radius: 10px;
		background: rgba(246, 250, 255, 1);
		box-sizing: border-box;
		margin-bottom: 10px;
		padding: 10px 15px;
		display: flex;
		align-items: center;
		cursor: pointer;
	}

	.item_err .option_num {
		border: 1px solid rgba(231, 62, 67, 1) !important;
		color: #fff !important;
		background: rgba(231, 62, 67, 1) !important;

	}

	.item_err .option_con {
		color: rgba(231, 62, 67, 1) !important;
	}

	.item_success {
		width: 100%;
		opacity: 1;
		border-radius: 10px;
		background: rgba(246, 250, 255, 1);
		box-sizing: border-box;
		margin-bottom: 10px;
		padding: 10px 15px;
		display: flex;
		align-items: center;
		cursor: pointer;

	}

	.item_success .option_num {
		border: 1px solid rgba(76, 197, 92, 1) !important;
		color: #fff !important;
		background: rgba(76, 197, 92, 1) !important;

	}

	.item_success .option_con {
		color: rgba(76, 197, 92, 1) !important;
	}

	.item_xuanzhong .option_num {
		border: 1px solid rgba(62, 136, 254, 1) !important;
		color: #fff !important;
		background-color: rgba(62, 136, 254, 1) !important;
	}


	.item_select {
		border: 1px solid rgba(62, 136, 254, 1) !important;
	}


	.btnbox {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 100px;

	}


	.btnbox .btn {
		cursor: pointer;
		width: 160px;
		height: 40px;
		opacity: 1;
		border-radius: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
		border: 1px solid rgba(62, 136, 254, 1);
		font-size: 14px;
		font-weight: 400;
		letter-spacing: 0px;
		color: rgba(62, 136, 254, 1);
		margin: 0 15px;
	}

	.btnbox .nextbtn {
		background: rgba(62, 136, 254, 1);
		color: rgba(255, 255, 255, 1);

	}


	.datika,.btnbox .showbtnsty{
		display: none;
	}
	.numbox {
		width: 100%;
		box-sizing: border-box;
		padding: 40px 30px 20px;
		display: flex;
		flex-wrap: wrap;
	}

	.numbox .item {
		cursor: pointer;
		margin-right: 22px;
		margin-bottom: 18px;
		border-radius: 50%;
		width: 35px;
		height: 35px;
		opacity: 1;
		background: rgba(255, 255, 255, 1);
		border: 1px solid rgba(210, 210, 210, 1);
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 16px;
		font-weight: 400;
		letter-spacing: 0px;
		color: rgba(128, 128, 128, 1);
	}

	.numbox .item:nth-child(5n+5) {
		margin-right: 0;
	}

	.cur {
		border: 1px solid rgba(62, 136, 254, 1) !important;
	}

	.num_select {
		background-color: rgba(62, 136, 254, 1) !important;
		border: 1px solid rgba(62, 136, 254, 1) !important;
		color: #fff !important;
	}


	.err {
		font-weight: 600 !important;
		border: 1px solid rgba(231, 62, 67, 0.15) !important;
		background: rgba(231, 62, 67, 0.15) !important;
		color: rgba(231, 62, 67, 1) !important;
	}

	.sucess {
		font-weight: 600 !important;
		border: 1px solid rgba(76, 197, 92, 0.15) !important;
		background: rgba(76, 197, 92, 0.15) !important;
		color: rgba(76, 197, 92, 1) !important;
	}


	.submit {
		width: 275px;
		height: 40px;
		opacity: 1;
		border-radius: 30px;
		background: rgba(62, 136, 254, 1);
		display: flex;
		align-items: center;
		justify-content: center;
		margin: auto;
		left: 1255px;
		font-size: 14px;
		font-weight: 400;
		letter-spacing: 0px;
		color: rgba(255, 255, 255, 1);
		cursor: pointer;

	}

	.answerKey {
		width: 100%;
		box-sizing: border-box;
		/* height: 60px; */
		opacity: 1;
		background: rgba(255, 255, 255, 1);
		position: relative;
		margin-top: 10px;
	}

	.answerKey .keybox {
		height: 60px;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.answerKey .keybox .item {
		font-size: 14px;
		font-weight: 400;
		letter-spacing: 0px;
		color: rgba(153, 153, 153, 1);
		position: relative;
		width: 50%;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		flex-direction: column;

	}

	.select_one {
		font-size: 18px;
		font-weight: 700;
		letter-spacing: 0px;
		color: rgba(76, 197, 92, 1);
	}

	.select_two {
		font-size: 18px;
		font-weight: 700;
		letter-spacing: 0px;
		color: rgba(231, 62, 67, 1);
	}

	.answerKey .keybox .item:first-child::after {
		position: absolute;
		content: '';
		clear: both;
		display: block;
		width: 2.27px;
		height: 30px;
		opacity: 1;
		background: rgba(204, 204, 204, 1);
		margin: auto;
		top: 0;
		bottom: 0;
		right: 0;
	}



	.analysis {
		margin-bottom: 10px;
		width: 100%;
		box-sizing: border-box;
		height: auto;
		opacity: 1;
		padding: 15px 20px;
		background: rgba(255, 255, 255, 1);
		border-top: 1px solid rgba(0, 0, 0, 0.1);
	}

	.analysis .analysisCon {
		position: relative;
		width: 100%;
		box-sizing: border-box;
		height: auto;
		border-radius: 5px;
		background: rgba(244, 247, 255, 1);
		padding: 55px 20px 20px;
	}

	.analysis .analysisCon .headertit {
		position: absolute;
		left: 0;
		top: 14px;
		width: 90.28px;
		height: 25.6px;
		opacity: 1;
		border-radius: 0 30px 30px 0;
		background: rgba(62, 136, 254, 1);
		display: flex;
		align-items: center;
		justify-content: center;

		font-size: 16px;
		font-weight: 700;
		letter-spacing: 0px;
		color: rgba(255, 255, 255, 1);

	}

	.analysis .analysisCon .infos {
		font-size: 16px;
		font-weight: 400;
		letter-spacing: 0px;
		line-height: 23.8px;
		color: rgba(56, 102, 156, 1);

	}




	.knowledgeTree .headertit {
		background-color: rgba(76, 197, 92, 1) !important;
	}

	.knowledgeTree .analysisCon {
		background-color: #fff !important;
	}

	.knowledgeTree .infos {
		font-size: 16px;
		font-weight: 400;
		letter-spacing: 0px;
		line-height: 23.8px;
		color: rgba(51, 51, 51, 1) !important;
	}

	.knowledgeTree .infos img {
		max-width: 100% !important;
	}



	/* 手机端答题卡 */
	.answerSheet {
		box-sizing: border-box;
		background-color: #fff !important;
		background-image: none;
		width: 90%;
	}

	.answerSheet .tit {
		height: 57px;
		box-sizing: border-box;
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		font-size: 16px;
		font-weight: 400;
		letter-spacing: 0px;
		color: rgba(0, 0, 0, 1);
	}

	.answerSheet .imgclose {
		position: absolute;
		right: 20px;
		top: 22px;
		width: 14px;
	}

	.answerSheet .numbox {
		padding-top: 30px;
	}

	.answerSheet .numbox .item {
		margin-right: 5vw;
		width: 10vw;
		height: 10vw;
	}

	.answerSheet .numbox .item:nth-child(5n+5) {
		margin-right: 0;
	}

	.answerSheet .submit {
		width: 80%;
	}

	.confirmAnswer {
		margin: auto;
		margin-top: 20px;
		cursor: pointer;
		width: 160px;
		height: 40px;
		opacity: 1;
		border-radius: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
		border: 1px solid rgba(62, 136, 254, 1);
		font-size: 14px;
		font-weight: 400;
		letter-spacing: 0px;
		background: rgba(62, 136, 254, 1);
		color: rgba(255, 255, 255, 1);
	}

	/* 判断题 */
	.determine {
		display: flex;
		align-items: center;
		justify-content: space-around;
		margin-top: 30px;
	}

	.determine .item {
		width: 42%;
		border-radius: 10px;
		background: rgba(246, 250, 255, 1);
		box-sizing: border-box;
		padding: 13px;
		text-align: center;
		cursor: pointer;
		font-size: 20px;
		color: rgba(51, 51, 51, 1);
	}

	.item_dui {
		background-color: rgba(76, 197, 92, 1) !important;
		color: #fff !important;
	}

	.item_cuo {
		color: #fff !important;
		background-color: rgba(231, 62, 67, 1) !important;
	}

	.item_determine_select {
		color: #fff !important;
		background-color: rgba(62, 136, 254, 1) !important;
	}




	/* 移动端 */
	@media screen and (max-width:760px) {

		.title {
			padding-left: 15px;

		}

		.answerbox_left {
			width: 100%;
		}

		.answerbox_left .top {
			height: auto;
		}

		.option_con {
			width: 88% !important;
		}

		.answerbox_right {
			display: none;
		}

		.answerbox_left .topicbox {
			padding: 18px 20px;
		}

		.btnbox {
			position: fixed;
			bottom: 0;
			left: 0;
			right: 0;
			background: #fff;
			z-index: 99;
			height: 80px;
			opacity: 1;
			background: rgba(255, 255, 255, 1);
			box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
		}
		.btnbox .showbtnsty{
			display: block;
			display: flex;
		}
		.datika {
			display: block;
			display: flex;
			flex-direction: column;
			align-items: center;
			font-size: 12px;
			font-weight: 400;
			letter-spacing: 0px;
			line-height: 17.38px;
			color: rgba(51, 51, 51, 1);

		}

		.datika img {
			width: 22px;
			height: 22px;
			margin-bottom: 4px;
		}

		.prevbtn {
			margin-left: 8%;
		}

		.btn {
			width: 29% !important;
		}

		.answerSheet .numbox .numbox {
			margin-right: 32px;
		}

		.answerSheet .numbox {
			overflow-y: auto;
			height: 280px;

		}

		.determine .item {
			padding: 10px;
		}

	}


	@media screen and (max-width:350px) {
		.answerSheet .numbox .item {
			margin-right: 4.5vw;
		}
	}


	.option_num,
	.answerKey .keybox,
	.answerKey .keybox,
	.item {
		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>